import { useState } from 'react';
import { getDiscrepancies } from 'services/fileManager/fileManagerServices';

export function useDiscrepancies() {
  const [listDiscrepancies, setListDiscrepancies] = useState([]);

  const loadDiscrepancies = async (limit = 10, token = '', direction = 'forward', sk = '', searchKey = '', case_id = '') => {
    try {
      const response = await getDiscrepancies(limit, token, direction, sk, searchKey, case_id);
      if (response && response?.data) {
        setListDiscrepancies(response.data?.tasks?.discrepancy_tasks || []);
        return response;
      }
    } catch (error) {
      console.log('Error loading discrepancies:', error);
      return null;
    }
  };

  const refreshDiscrepancies = async (limit = 10, searchKey = '', case_id = '') => {
    return await loadDiscrepancies(limit, '', 'forward', '', searchKey, case_id);
  };

  return {
    listDiscrepancies,
    loadDiscrepancies,
    refreshDiscrepancies,
  };
}
